import { IOption } from 'ng-select';
import { Component, OnInit, Input,ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { PMS } from '../preventive-maintenance/pms-service';
import {Pipe} from '@angular/core';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
declare var $:any;
import * as moment from 'moment/moment';

import { Popup } from 'ng2-opd-popup';

@Component({
  selector: 'app-postPoned-form',
  templateUrl: './postPoned-form.component.html',
  styleUrls: ['./postPoned-form.component.scss']
  //providers: [FormBuilderComponent]
})


export class PostPonedFormComponent implements OnInit {
  TechnicianNamePlaceholder="Select a Technician Name"
	msgtext:string;
   ListTechnicianName:any[]=[];
   Listbranchdetails=[];
   // ListOfCheckListMaster:any[] = [];
   //ListTechnicianName:Array<IOption>=[];
   prepostponeDate:any;
   techinicianDetails: Array<IOption> = [];
   ListOfCheckListMaster:Array<IOption> = [];
   myFormsOption:Array<IOption>=[];
 	ListOfCustomermaster:any[] = [];
 	ListOfFields:any[] = [];
 	ListOfSecondFields:any[] = [];
   technicianNameerr:boolean=false;
 	clientName:any;
 	serialnumber:any;
 	mclocation:any;
 	noofService:any;
 	startdate:any;
 	endDate:any;
 	make:any;
 	intervalofservice:any;
 	model:any;
 	hmrHours:any;
 	technicianName:any;
 	lastServiceType:any;
 	lastServiceHour:any;
 	yearofmanufacturer:any;
 	branch:any;
 	serviceContractOffered:any;
 	contractReference:any;
 	clientPhonenumber:any;
 	email:any;
 	ListSerialNumber:any[] = [];
 	textField:boolean = true;
 	dropdownField:boolean = false;
 	getListClientdetails:any[] = [];
 	showModal:boolean = false;
 	chooseClientname:any;
 	dialogConfirmation:any;
 	serviceScheduleNumber:any; 
	serviceCarriedOutDate:any;
	nextServiceRemainderDays:any;
	nextServiceType:any;
	preventiveId:any;
	postPonedRemainderDays:any;
	postPonedTakenDate:any;
	isValid:boolean = true;
	reqMakeId:number;
	reqmodelId:number;
	countValue;
	CustomerName:any;
	ListOfPreventiveMaintenanceDetails = [];
	serviceoptionType:any;
	prePonedRemainderDays:any;
  updateValue='no';
  serialNumbercounterr:boolean=false;
  newextensiondate:any;
  @ViewChild('Newaddpost') Newaddpost: Popup;
  @ViewChild('Newaddpre') Newaddpre: Popup;
  @ViewChild('postpone') postpone: Popup;
  @ViewChild('serviceupdation') serviceupdation: Popup;
  @ViewChild('ContractExtension') ContractExtension: Popup;
  FirstDate:any;
  PreCount:any;
  currentSerialNumber:any;
  mindate:any;
  maxdate:any;
  dayValue:number=30;
  prepostdays:any=0;
  @ViewChild('alert') alert: Popup;
  orgId:number;
  userId:number; 
  contractLevel:number;
  pprestrictDate;
  page;
  serviceValidation:number=0;
	constructor(private toastyService:ToastyService,private toastyConfig: ToastyConfig,private http: Http,private router:Router,private route : ActivatedRoute){}

	ngOnInit() {
		    
    if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
       window.location.href = 'https://still.alshirawi.com/highmessaging/';
    } else {
      this.orgId=this.route.params['value'].orgId;
      this.userId=this.route.params['value'].userId;
      console.log('OrgId '+ this.orgId);
      console.log('UserId '+ this.userId);
    }
    this.currentSerialNumber = this.route.params['value'].serialNumber;
    this.serviceoptionType =  this.route.params['value'].type;

		//this.serviceoptionType = 'servicePostpone';
    this.gteValue();
		this.getTechnicianName();
		this.getAllDetailsFromCheckListMaster ();
		//this.getAllPreventiveMaintenanceDetails();
		this.ListOfFields.push({
	  		'PartNumber': '',
	  		'description': '',
	  		'quantity':'',
	  		'UnitPrice':'',
	  		'SellingPrice':'',
	  		'serviceType':'',
	  		'costType':''
	  	});
	  	this.ListOfSecondFields.push({
        'hmr':'',
        'date':'',
        'serviceType':'',
        'labourCost':'',
        'labour_hour':'',
        'SparesCost':'',
        'travelCost':'',
        'travel_hour':'',
        'Consumables':'',
        'disable':'No'
      });
	  	this.postPonedTakenDate = moment().format('MM/DD/YYYY');
      let pusharrpostpre=[];
      if(this.serviceoptionType=="servicePostpone"){
        pusharrpostpre.push({'value':"servicePostpone",'label':'Service Postpone'});
      }
      if(this.serviceoptionType=="servicePrepone"){
        pusharrpostpre.push({'value':"servicePrepone",'label':'Service Prepone'});
      }
      this.myFormsOption=pusharrpostpre;
	}
  
  backtoserviceContactpage(){
    this.router.navigate(['node/serviceContract', {orgId:this.orgId,userId:this.userId,serialNumber:this.serialnumber}]);
  }

  stay() {
    this.gteValue()
    $("#Newaddpost").modal('hide');
    $("#Newaddpre").modal('hide');
   
  }

  Back() {
    $("#Newaddpost").modal('hide');
    $("#Newaddpre").modal('hide');
    
    this.router.navigate(['node/serviceContract', {orgId:this.orgId,userId:this.userId,serialNumber:this.route.params['value'].serialNumber,type:this.serviceoptionType}]);
  }

  // addpre() {
  //   this.Newaddpre.hide();
  // }

  no() {
    this.postpone.hide();
  }
  gettechdetails(getTechName) {
    if(getTechName == "" || getTechName == undefined) {
       
      this.technicianNameerr=true;
    } else {
       
      this.technicianNameerr=false;
    }
  }

  getTechnicianName() {
       
    let techObj = {
      'orgId':this.orgId
    }
    return this.http.post('/api/getTechniciansName', techObj).subscribe(
    res => {
     
      res.json();
      this.ListTechnicianName = res.json();
      this.TechnicianDetailsload();
    },(err)=>{
     
    })
  }

  TechnicianDetailsload(){
    let technicianArr = []
    for(var i=0;i<this.ListTechnicianName.length;i++) {
      let obj = {
        'label':this.ListTechnicianName[i].FIRST_NAME +' '+ this.ListTechnicianName[i].LAST_NAME,
        'value':this.ListTechnicianName[i].ID
      }
      technicianArr.push(obj);
    }
    this.techinicianDetails = technicianArr;
   }
	backToMyForm() {
      this.router.navigate(['myform']);
    }
    getbranchdetails(){
      let branchObj = {
        'orgId':this.orgId
      }
      return this.http.post("/api/getbranchdetails",branchObj).subscribe(res=>{
        let responseBranch=res.json();
        this.Listbranchdetails=responseBranch;
       
      },err=>{
       
     
      })
    }


	getAllDetailsFromCheckListMaster () {
    let reqService = {
      'orgId':this.orgId
    }
  		return this.http.post('/api/getServiceTypedetails', reqService).subscribe(
     	res => {
         this.ListOfCheckListMaster = res.json();
         let pusharr=[];
         for(let i=0;i<res.json().length;i++){
          pusharr.push({'value':res.json()[i]._id.toString(),'label':res.json()[i].servicetype.toUpperCase()})
         }
         this.ListOfCheckListMaster=pusharr;
      },(err) =>{
        if(err.status != 200){
          this.msgtext = "Unable to load the Value";
          this.getWarningFunction(this.msgtext);
        }
      })
  		
  	}

    gteValue() {
     this.getbranchdetails();
      let serialObj = {
          'serialNumber':this.currentSerialNumber,
          'orgId':this.orgId
        }
        return this.http.post('/api/CheckSerialNumberExistOrNot', serialObj).subscribe(
        res => {
              
          let SerialResponse = res.json();
          this.getListClientdetails = SerialResponse;
          if(SerialResponse.length>0) {

            let SerialNumberCount = SerialResponse.length-1;
            // this.clientName = this.getListClientdetails[SerialNumberCount].client_Name;
            // for(let i=0;i<this.ListOfCustomermaster.length;i++) {
            //   if(this.ListOfCustomermaster[i]._id == parseInt(this.clientName)) {
            //     this.CustomerName = this.ListOfCustomermaster[i].customer_Name;
            //   }
            // }
            this.preventiveId = this.getListClientdetails[SerialNumberCount]._id;;
            // this.clientName = this.CustomerName;
            this.serialnumber = this.getListClientdetails[SerialNumberCount].serial_Number;
            this.mclocation = this.getListClientdetails[SerialNumberCount].mcLocation;
            this.clientPhonenumber = this.getListClientdetails[SerialNumberCount].phone_Number;
            this.email = this.getListClientdetails[SerialNumberCount].email;
            this.reqMakeId = this.getListClientdetails[SerialNumberCount].make;
            this.getmakedetails();
            this.reqmodelId = this.getListClientdetails[SerialNumberCount].model;
            this.getmodeldetails();
            this.hmrHours = this.getListClientdetails[SerialNumberCount].hmr;
            this.contractLevel = this.getListClientdetails[SerialNumberCount].contractLevel;
            this.technicianName = this.getListClientdetails[SerialNumberCount].technician_Name;
            for(let i=0;i<this.ListTechnicianName.length;i++){
              if(this.technicianName==this.ListTechnicianName[i].ID){
                this.TechnicianNamePlaceholder=this.ListTechnicianName[i].FIRST_NAME +' '+ this.ListTechnicianName[i].LAST_NAME;
              }
            }
          
            this.lastServiceType = this.getListClientdetails[SerialNumberCount].last_Service_Type;
            this.lastServiceHour = this.getListClientdetails[SerialNumberCount].last_Service_Hours;
            this.yearofmanufacturer = this.getListClientdetails[SerialNumberCount].year_Of_manufacturer;
            this.branch = this.getListClientdetails[SerialNumberCount].branch;
            for(let i=0;i<this.Listbranchdetails.length;i++){
              if(this.Listbranchdetails[i]._id==this.branch){
                this.branch=this.Listbranchdetails[i].branchAlias
              }
            }
            this.serviceContractOffered = this.getListClientdetails[SerialNumberCount].service_Contract_Offered;
            this.contractReference = this.getListClientdetails[SerialNumberCount].contract_Reference;
            this.noofService = this.getListClientdetails[SerialNumberCount].no_Of_Service;
            this.intervalofservice = this.getListClientdetails[SerialNumberCount].days_Interval_Of_Service;
            this.startdate = this.getListClientdetails[SerialNumberCount].start_Date;
            this.endDate = this.getListClientdetails[SerialNumberCount].end_Date;
            this.serviceScheduleNumber = this.getListClientdetails[SerialNumberCount].serviceScheduleDay;
            this.ListOfFields = this.getListClientdetails[SerialNumberCount].Sparedetails
            this.ListOfSecondFields = this.getListClientdetails[SerialNumberCount].Servicedetails;
            this.serviceCarriedOutDate = this.ListOfSecondFields[this.serviceScheduleNumber-1].date;
            this.nextServiceRemainderDays = this.getListClientdetails[SerialNumberCount].remainderday;
            this.postPonedTakenDate = moment().format('YYYY-MM-DD');
            this.FirstDate = this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)-1].date;
            // if(this.serviceScheduleNumber == 1) {
            //   this.mindate = moment(this.startdate).add(1, 'days').format('YYYY-MM-DD');
            // } else {
            //   this.mindate = this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)-2].date;
            //   this.mindate = moment(this.mindate).add(1, 'days').format('YYYY-MM-DD');
            // }
            if(this.route.params['value'].type == 'servicePostpone') {
              this.postPonedRemainderDays=this.FirstDate;
              this.prepostponeDate=this.postPonedRemainderDays;
              this.page= 'Postpone';
            } else if(this.route.params['value'].type == 'servicePrepone') {
              this.prePonedRemainderDays=this.FirstDate;
              this.prepostponeDate= this.prePonedRemainderDays;
              this.page= 'Prepone';
            }
            
            // if(this.intervalofservice <= 30) {
            //    this.maxdate = moment(this.FirstDate).add(this.intervalofservice, 'Days').format('YYYY-MM-DD');
            // } else {
            //   //this.intervalofservice=30;
            //   this.maxdate = moment(this.FirstDate).add(this.intervalofservice, 'Days').format('YYYY-MM-DD');
            // }
           

          } else {
        
            this.getEmptyAllField();
            this.serialnumber = this.currentSerialNumber
          }
        },(err)=>{
        
          this.getEmptyAllField();
          this.msgtext = "Unable to load Serial Number details";
          this.getWarningFunction(this.msgtext);
        })
     
     }

  	// getAllPreventiveMaintenanceDetails() {
    
   //    let PMSObj = {
   //        'orgId':this.orgId
   //      }
   //    return this.http.post('/api/getAllPreventiveMaintenanceDetails', PMSObj).subscribe(
   //     res => {
   //        let CustomerArr = []
   //        this.ListOfPreventiveMaintenanceDetails = res.json();
   //        for(var i=0;i<this.ListOfPreventiveMaintenanceDetails.length;i++) {
   //          if(CustomerArr.length>0) {
   //            let customerCount=0;
   //            for(let k=0;k<CustomerArr.length;k++) {
   //              if(this.ListOfPreventiveMaintenanceDetails[i].client_Name == CustomerArr[k].client_id) {
   //                customerCount=1;
   //              } else {
                  
   //              }
   //            }
   //            if(customerCount == 0) {
   //              let cObj = {
   //                'client_id':this.ListOfPreventiveMaintenanceDetails[i].client_Name
   //              }
   //              CustomerArr.push(cObj);
   //            }else {

   //            }
              
   //          } else {
   //            let cObj = {
   //              'client_id':this.ListOfPreventiveMaintenanceDetails[i].client_Name
   //            }
   //            CustomerArr.push(cObj);
   //          }
              
   //        }
   //        let UniqueCustomer = CustomerArr.filter(function(item, i, ar){ 
   //        return ar.indexOf(item) === i; });
   //        console.log("UniqueCustomer " + UniqueCustomer);
   //        let CustomerObj = {
   //          'orgId':this.orgId
   //        }
   //        return this.http.post('/api/getCustomerMasterDetails', CustomerObj).subscribe(
   //        res => {
   //          this.ListOfCustomermaster = [];
   //          let customerDetails = res.json();
   //          for(var k=0;k<UniqueCustomer.length;k++) {
   //            for(var m=0;m<customerDetails.length;m++) {
   //              if(parseInt(UniqueCustomer[k].client_id) == customerDetails[m]._id) {
   //                let Fobj = {
   //                  '_id':customerDetails[m]._id,
   //                  'customer_Name':customerDetails[m].customer_Name
   //                }
   //                this.ListOfCustomermaster.push(Fobj);
   //              }
   //            }
   //          }
   //           this.gteValue();
   //        },(err) =>{
           
   //          if(err.status != 200){
   //            this.msgtext = "Unable to load the Value";
   //            this.getWarningFunction(this.msgtext);
   //          }
   //        })
   //      },(err) =>{
     
   //        if(err.status != 200){
   //          this.msgtext = "Unable to load the Value";
   //          this.getWarningFunction(this.msgtext);
   //        }
   //      })

   //  }

  	// getCustomerdetails(getName) {
  	// 	    
  	// 	this.chooseClientname = getName;
  		
   //    for(let i=0;i<this.ListOfCustomermaster.length;i++) {
   //      if(this.ListOfCustomermaster[i]._id == parseInt(this.clientName)) {
   //        this.CustomerName = this.ListOfCustomermaster[i].customer_Name;
   //      }
   //    }
  	// 	let redName = {
  	// 		'clientName':getName
  	// 	}
  	// 	return this.http.post('/api/getPreventiveMaintenanceService', redName).subscribe(
   //   	res => {
   //   		    
   //   		this.getListClientdetails = res.json();
   //   		if(this.getListClientdetails.length>0) {
     			
				
   //   			// $("#myModal").modal('show')
     			
   //   				this.textField = false;
  	// 				this.dropdownField = true;
  	// 				this.clientName = getName;
  	// 				this.ListSerialNumber = [];
	  //    			for(var i=0;i<this.getListClientdetails.length;i++) {
	  //    				let obj = {
	  //    					'serialNumber':this.getListClientdetails[i].serial_Number
	  //    				}
	  //    				this.ListSerialNumber.push(obj);
	  //    			}
					
					
   //          if(this.updateValue == 'yes') {
   //            //this.getSerialNumberdetails(this.serialnumber);

   //          } else {
   //            this.getEmptyAllField();
   //            this.chooseClientname = getName;
   //            for(var i=0;i<this.ListOfCustomermaster.length;i++) {
   //              if(this.ListOfCustomermaster[i]._id == getName) {
   //                this.clientPhonenumber = this.ListOfCustomermaster[i].phone_Number;
   //                this.email = this.ListOfCustomermaster[i].email;
   //                this.clientName = getName;
   //              }
   //            }
   //          }
     			
   //   		} else {
   //   			this.textField = true;
			// 	  this.dropdownField = false;
   //   			for(var i=0;i<this.ListOfCustomermaster.length;i++) {
		 //  			if(this.ListOfCustomermaster[i]._id == getName) {
		 //  				this.clientPhonenumber = this.ListOfCustomermaster[i].phone_Number;
		 //  				this.email = this.ListOfCustomermaster[i].email;
		 //  				this.clientName = getName;
		 //  			}
		 //  		}
		 //  		this.ListSerialNumber = [];
		 //  		this.getEmptyAllField();
   //   		}
	  //     },(err) =>{
	  //       if(err.status != 200){
	  //         this.msgtext = "Unable to load the Value";
	  //         this.getWarningFunction(this.msgtext);
	  //       }
	  //   })
  		
  	// }

  	getmakedetails() {
      let makeObj = {
        'makeId':this.reqMakeId,
        'orgId':this.orgId
      }
      return this.http.post('/api/getMakedetailsBasedOnId', makeObj).subscribe(
       res => {
         let response = res.json();
         if(response.length>0) {
           this.make = response[0].make.toUpperCase();;
         }
       })
    }
    getmodeldetails() {
      let modelObj = {
        'modelId':this.reqmodelId,
        'orgId':this.orgId
      }
      return this.http.post('/api/getModeldetailsBasedOnId', modelObj).subscribe(
       res => {
         let response = res.json();
         if(response.length>0) {
           this.model = response[0].model.toUpperCase();;
         }
       })
    }

  	

  postponedRemainderDays(value) {
        
    this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)-1].date = value;
    let firstDate = new Date(moment(this.FirstDate).format('YYYY MM DD'));
    let secondDate = new Date(moment(value).format('YYYY MM DD'));
    let oneDay = 24*60*60*1000;
    this.prepostdays = Math.round(Math.abs((secondDate.getTime() - firstDate.getTime())/(oneDay)));

    let k=0;
    for(var i=this.serviceScheduleNumber-1;i<this.ListOfSecondFields.length;i++) {
      let addValue = this.intervalofservice*k;
      this.ListOfSecondFields[i].date = moment(value).add(addValue,'days').format('YYYY-MM-DD');
      k++;
    }

    if(this.serviceScheduleNumber-1 > 1) {
        if(this.ListOfSecondFields[this.serviceScheduleNumber-2].date > this.ListOfSecondFields[this.serviceScheduleNumber-1].date) {
          alert('date should be greater than previous service date');
          this.ListOfSecondFields[this.serviceScheduleNumber-1].date = '';
        } 

    }
      if(this.ListOfSecondFields[this.ListOfSecondFields.length-1].date > this.endDate || this.ListOfSecondFields[this.ListOfSecondFields.length-1].date < this.startdate) {
          $('html, body').animate({ scrollTop: 0 }, 'fast');
          //alert('Service Date should be Under service Contract Start date and End date');
         
          for(var i=this.serviceScheduleNumber-1;i<this.ListOfSecondFields.length;i++) {
            this.ListOfSecondFields[i].date = '';
          }
         
          this.serialnumber = this.serialnumber;
          this.startdate = this.startdate;
          this.endDate = this.endDate;
          $("#alert").modal('show');
          // this.alert.options = {
          //   showButtons: false, // You can hide this in case you want to use custom 
          //   color: "#4180ab",
          //   header: "Service Updation Form"
          // };
          // this.alert.show(this.alert.options);

        }
      
  }

  yes() {
    // this.alert.hide();
    $("#alert").modal('hide');
    $("#ContractExtension").modal('show');
      // this.ContractExtension.options = {
      //   showButtons: false, // You can hide this in case you want to use custom 
      //   color: "#4180ab",
      //   widthProsentage:50,
      //   header: "Contract Extension"
      // };
      // this.ContractExtension.show(this.ContractExtension.options);

    }

    alertno() {
      $("#alert").modal('hide');
      // this.alert.hide();
      this.postPonedRemainderDays='';
      this.prePonedRemainderDays='';
    }

  preponedRemainderDays(value) {
        
    if(this.prePonedRemainderDays < this.startdate) {
      alert('Prepone date should be greater than service contract start date');
      this.prePonedRemainderDays = this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)-1].date;
    } else {
      this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)-1].date = value;
      let firstDate = new Date(moment(this.FirstDate).format('YYYY MM DD'));
      let secondDate = new Date(moment(value).format('YYYY MM DD'));
      let oneDay = 24*60*60*1000;
      this.prepostdays = Math.round(Math.abs((secondDate.getTime() - firstDate.getTime())/(oneDay)));

      let k=0;
      for(var i=this.serviceScheduleNumber-1;i<this.ListOfSecondFields.length;i++) {
        let addValue = this.intervalofservice*k;
        this.ListOfSecondFields[i].date = moment(value).add(addValue,'days').format('YYYY-MM-DD');
        k++;
      }

      if(this.serviceScheduleNumber-1 > 1) {
          if(this.ListOfSecondFields[this.serviceScheduleNumber-2].date > this.ListOfSecondFields[this.serviceScheduleNumber-1].date) {
            alert('date should be greater than previous service date');
            this.ListOfSecondFields[this.serviceScheduleNumber-1].date = '';
          } else if(this.ListOfSecondFields[this.ListOfSecondFields.length-1].date > this.endDate || this.ListOfSecondFields[this.ListOfSecondFields.length-1].date < this.startdate) {
            $('html, body').animate({ scrollTop: 0 }, 'fast');
            //alert('Service Date should be Under service Contract Start date and End date');
           
            for(var i=this.serviceScheduleNumber-1;i<this.ListOfSecondFields.length;i++) {
              this.ListOfSecondFields[i].date = '';
            }
           
            this.serialnumber = this.serialnumber;
            this.startdate = this.startdate;
            this.endDate = this.endDate;
            $("#alert").modal('show');
            // this.alert.options = {
            //   showButtons: false, // You can hide this in case you want to use custom 
            //   color: "#4180ab",
            //   header: "Service Updation Form"
            // };
            // this.alert.show(this.alert.options);

          }
        }
    }
    
  }

    // yes() {
    //   this.postpone.hide();
    //   this.serviceupdation.options = {
    //     showButtons: false, // You can hide this in case you want to use custom 
    //     color: "#4180ab",
    //     widthProsentage:70,
    //     header: "Next Service Updation"
    //   };
    //   this.serviceupdation.show(this.serviceupdation.options);
      
    // }

    updatecancel() {
      this.serviceupdation.hide();
    }

    update() {
      let updateObj = {
        'pmId':this.preventiveId,
        'serviceTable':this.ListOfSecondFields,
        'updated_By':this.userId,
        'updated_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
      }
      return this.http.post('/api/nextServiceUpdations', updateObj).subscribe(
        res => {
              
          let getresponse = res.json();
          this.updateValue = 'yes';
          this.serviceupdation.hide();
          //this.getCustomerdetails(this.clientName);
          //this.getSerialNumberdetails(this.serialnumber);

        })

      
    }

    serviceDate(date, IndexCount) {
          
      for(var i=IndexCount;i<this.ListOfSecondFields.length;i++) {
        let addValue = this.intervalofservice*i;
        this.ListOfSecondFields[i].date = moment(date).add(addValue,'days').format('YYYY-MM-DD');
        
      }
      
      if(this.ListOfSecondFields[this.ListOfSecondFields.length-1].date > this.endDate || this.ListOfSecondFields[this.ListOfSecondFields.length-1].date < this.startdate) {
        alert('Service Date should be Under service Contract Start date and End date! or You can Extend Service Contract.');
       
        for(var i=IndexCount;i<this.ListOfSecondFields.length;i++) {
           this.ListOfSecondFields[i].date = '';
        }
        
      } else {

      }
      
    }

    contractExtension() {
      //this.serviceupdation.hide();
      $("#ContractExtension").modal('show');
      // this.ContractExtension.options = {
      //   showButtons: false, // You can hide this in case you want to use custom 
      //   color: "#4180ab",
      //   widthProsentage:50,
      //   header: "Contract Extension"
      // };
      // this.ContractExtension.show(this.ContractExtension.options);
    }

    // cancel() {
    //   this.ContractExtension.hide();
    // }

    save() {
      if(this.newextensiondate == "" || this.newextensiondate == null || this.newextensiondate == undefined) {
        alert('please enter the Extension date');
      } else {
        let CEobj = {
          'serialNumber':this.serialnumber,
          'startDate':this.startdate,
          'endDate':this.endDate,
          'extensionDate':this.newextensiondate,
          'PM_ID':this.preventiveId,
          'contractLevel':this.contractLevel,
          'orgId':this.orgId,
          'created_By':this.userId,
          'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
        }
        return this.http.post('/api/extendServiceContractDuration', CEobj).subscribe(
        res=>{
          let Response = res.json();
          $("#ContractExtension").modal('hide');
          // this.ContractExtension.hide();
          alert('service contract Extension successfully done.');
          this.updateValue = 'yes';
         //this.getCustomerdetails(this.clientName);
          this.gteValue();
        },(err)=> {
          alert('unable to extend the service contract');
        })
      }
      
    }

    extensiondate(date) {
          
      if(date < this.endDate) {
        alert('Extension date should be greater than End date');
        this.newextensiondate = '';
      } 
    }

  	serviceoption(selctedValue) {
  		if(selctedValue == 'servicePostpone') {
  			if(this.prePonedRemainderDays == "" || this.prePonedRemainderDays == null || this.prePonedRemainderDays == undefined) {

  			} else {
  				let getDate = this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)-1].date;
  				let Finaldate = moment(getDate).add(this.prePonedRemainderDays, 'Days').format('YYYY-MM-DD');
  				this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)-1].date = Finaldate;
  				this.prePonedRemainderDays = '';
  			}
  		} else if(selctedValue == 'servicePrepone') {
  			if(this.postPonedRemainderDays == "" || this.postPonedRemainderDays == null || this.postPonedRemainderDays == undefined) {

  			} else {
  				let getDate = this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)-1].date;
  				let Finaldate = moment(getDate).subtract(this.postPonedRemainderDays, 'Days').format('YYYY-MM-DD');
  				this.ListOfSecondFields[parseInt(this.serviceScheduleNumber)-1].date = Finaldate;
  				this.postPonedRemainderDays = '';
  			}
  		}
  	}
// if(this.clientName == "" || this.clientName == undefined || this.clientName == null) {
//         this.isValid = false;
//         document.body.scrollTop = 0;
//         document.documentElement.scrollTop = 0;
//       } else
  	Submit () {
      this.serviceValidation=0;
      for(let s=0;s<this.ListOfSecondFields.length;s++) {
        if(this.ListOfSecondFields[s].date == null || this.ListOfSecondFields[s].date == "" || this.ListOfSecondFields[s].date == undefined) {
          this.serviceValidation=1;

        } else if(this.ListOfSecondFields[s].service_Type == null || this.ListOfSecondFields[s].service_Type == "" || this.ListOfSecondFields[s].service_Type == undefined) {
          this.serviceValidation=1;
        } else if(this.ListOfSecondFields[s].labour_Cost == null || this.ListOfSecondFields[s].labour_Cost == "" || this.ListOfSecondFields[s].labour_Cost == undefined) {
          this.serviceValidation=1;
        } else if(this.ListOfSecondFields[s].travel_Cost == null || this.ListOfSecondFields[s].travel_Cost == "" || this.ListOfSecondFields[s].travel_Cost == undefined) {
          this.serviceValidation=1;
        } 
      }
  		
  		 if(this.serialnumber == "" || this.serialnumber == undefined || this.serialnumber == null) {
  			this.isValid = false;
  			document.body.scrollTop = 0;
    		document.documentElement.scrollTop = 0;
  		} else if(this.serviceoptionType == 'servicePrepone' && (this.prePonedRemainderDays == "" || this.prePonedRemainderDays == undefined || this.prePonedRemainderDays == null)) {
  			this.isValid = false;
  			document.body.scrollTop = 0;
    		document.documentElement.scrollTop = 0;
  			
  		}else if (this.serviceoptionType == 'servicePostpone' && (this.postPonedRemainderDays == "" || this.postPonedRemainderDays == undefined || this.postPonedRemainderDays == null)) {
  			this.isValid = false;
  			document.body.scrollTop = 0;
    		document.documentElement.scrollTop = 0;
  		} else if (this.postPonedTakenDate == "" || this.postPonedTakenDate == undefined || this.postPonedTakenDate == null) {
  			this.isValid = false;
  			document.body.scrollTop = 0;
    		document.documentElement.scrollTop = 0;
  		} else if(this.serviceValidation == 1) {
        alert('please fill the service Date details');
      } else {
        let reqObj = {}
        if(this.serviceoptionType == 'servicePostpone') {
          reqObj = {
              'pm_Id' :this.preventiveId,
              'serialNumber':this.serialnumber,
              'postPoned_Remainder_Days' :this.prepostdays,
              'postPoned_Taken_Date' :this.postPonedTakenDate,
              'Servicedetails':this.ListOfSecondFields,
              'schedularNumber':this.serviceScheduleNumber,
              'type':this.serviceoptionType,
              'contractLevel':this.contractLevel,
              'orgId':this.orgId,
              'created_By':this.userId,
              'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
          }
        } else if(this.serviceoptionType == 'servicePrepone') {
          reqObj = {
              'pm_Id' :this.preventiveId,
              'serialNumber':this.serialnumber,
              'postPoned_Remainder_Days' :this.prepostdays,
              'postPoned_Taken_Date' :this.postPonedTakenDate,
              'Servicedetails':this.ListOfSecondFields,
              'schedularNumber':this.serviceScheduleNumber,
              'contractLevel':this.contractLevel,
              'type':this.serviceoptionType,
              'orgId':this.orgId,
              'created_By':this.userId,
              'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
          }
        }
  			
			return this.http.post('/api/addPostPonedForm', reqObj).subscribe(
	     	res => {
	     		    
	     		let Response = res.json();
	     		this.getEmptyAllField();
	     		//this.msgtext = "New Value Added Successfully";
	     		this.postPonedRemainderDays = "";
	     		this.postPonedTakenDate = "";
	     		this.clientName = "";
	     		this.serialnumber = "";
          this.prePonedRemainderDays = '';
          
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          if(this.serviceoptionType == 'servicePostpone') {
            $("#Newaddpost").modal('show');
            //  this.Newaddpost.options = {
            //   showButtons: false, // You can hide this in case you want to use custom 
            //   color: "#4180ab",
            //   widthProsentage:40,
            //   header: "Service Postpone Form"
            // };
            // this.Newaddpost.show(this.Newaddpost.options);
          } else if(this.serviceoptionType == 'servicePrepone') {
            $("#Newaddpre").modal('show');
            // this.Newaddpre.options = {
            //   showButtons: false, // You can hide this in case you want to use custom 
            //   color: "#4180ab",
            //   widthProsentage:40,
            //   header: "Service Prepone Form"
            // };
            // this.Newaddpre.show(this.Newaddpre.options);
          }
          //this.router.navigate(['node/serviceContract', {serialNumber:this.serialnumber}]);
          this.serviceoptionType = 'servicePostpone'
	     	},(err)=>{
	     		this.msgtext = "Unable to Add the Data";
	        	this.getWarningFunction(this.msgtext);
	     	})
  		}
  		
  	}

  	reset() {
  		this.getEmptyAllField();
  	}

  	getEmptyAllField() {
	  	this.ListOfSecondFields = [];
	  	
	  	this.ListOfSecondFields.push({
        'hmr':'',
        'date':'',
        'serviceType':'',
        'labourCost':'',
        'labour_hour':'',
        'SparesCost':'',
        'travelCost':'',
        'travel_hour':'',
        'Consumables':'',
        'disable':'No'
      });
	  	this.clientName = '';
  		this.serialnumber = '';
  		this.mclocation = '';
  		this.noofService = '';
  		this.startdate = '';
  		this.endDate = '';
  		this.make = '';
  		this.intervalofservice = '';
  		this.model = '';
  		this.hmrHours = '';
  		this.technicianName = '';
  		this.lastServiceType = '';
  		this.lastServiceHour = '';
  		this.yearofmanufacturer = '';
  		this.branch = '';
  		this.serviceContractOffered = '';
  		this.contractReference = '';
  		this.clientPhonenumber = '';
  		this.email = '';
  		this.serviceCarriedOutDate = '';
      this.nextServiceRemainderDays = '';
      this.TechnicianNamePlaceholder="Select a Technician Name"
	  }

  	getWarningFunction(errMsg) {
	    var toastOptions:ToastOptions = {
	        title: "View page",
	        msg: errMsg,
	        showClose: true,
	        timeout: 3000,
	        theme: 'bootstrap',
	        onAdd: (toast:ToastData) => {
	        },
	        onRemove: function(toast:ToastData) {
	        }
	      };
	    this.toastyService.warning(toastOptions);
	}//getWarningFunction end here


	getSuccessFunction(successMsg){
	    var toastOptions:ToastOptions = {
	      title: "View page",
	      msg: successMsg,
	      showClose: true,
	      timeout: 3000,
	      theme: 'bootstrap',
	      onAdd: (toast:ToastData) => {
	      },
	      onRemove: function(toast:ToastData) {
	      }
	    };
	    this.toastyService.success(toastOptions);
	}//getSuccessFunction end here
}


// WEBPACK FOOTER //
// ./client/app/postPoned-form/postPoned-form.component.ts